import { ObjectLiteral } from 'interfaces'
import { StackDTO } from '@ketch-com/figurehead'

const NO_PURPOSES_REMAINING_WARNING = 'This group will be disabled because it has no purposes'

type GetStackWarningsArgs = {
  stacks: StackDTO[]
  purposeCode: string
}

/**
 *
 * @param stacks Array of StackDTO objects
 * @param purposeCode the purpose code for which the "what if it is disabled" simulation is being run to determine any warnings are needed
 * @returns An array of warnings.  Each warning contains the implicated Stack and the affected Group within that Stack
 */
export const getStackWarnings = ({ stacks, purposeCode }: GetStackWarningsArgs) => {
  const stackWarnings = stacks?.reduce((acc, stack) => {
    const warning: ObjectLiteral = {}

    const stackAfterPurposeRemoved = {
      ...stack,
      groups: (stack.groups || [])?.map(g => {
        return {
          ...g,
          purposes: (g?.purposes || [])?.filter(p => p?.code !== purposeCode),
        }
      }),
    }

    const groupsPurposesLengthsArray: number[] = []
    stackAfterPurposeRemoved?.groups?.forEach?.(group => {
      groupsPurposesLengthsArray.push(group?.purposes?.length || 0)

      if (group?.purposes?.length === 0) {
        warning[group?.name as string] = NO_PURPOSES_REMAINING_WARNING
      }
    })

    const sumGroupsPurposesLengths = groupsPurposesLengthsArray.reduce((a, b) => a + b, 0)

    return {
      ...acc,
      [stack.name as string]: {
        ...(sumGroupsPurposesLengths !== 0 && {
          ...warning,
        }),

        ...(sumGroupsPurposesLengths === 0 && {
          stackWillBeDeleted: true,
        }),
      },
    }
  }, {} as ObjectLiteral)

  const warningsPayload = Object.entries(stackWarnings || {}).filter(
    ([_, warnings]) => Object.keys(warnings).length > 0,
  )

  return warningsPayload
}
